import * as React from 'react';
import { INotificationListProps, INotificationEventManager } from './notification-types';
import { NotificationList } from './notification-list';
import { NotificationEventContext, createNotificationEventManager } from './notification-event-context';

interface IWithNotificationListProps extends Omit<INotificationListProps, 'eventManager'> {
    children: React.ReactNode;
    eventManager?: INotificationEventManager;
}

const NOOP = () => { /*NOOP*/ };

// NotificationManager is used to manage notifications programatically from logical code.
export const NotificationManager: Pick<INotificationEventManager, 'showNotifications' | 'clearNotifications' | 'removeNotification'> = {
    clearNotifications: NOOP,
    removeNotification: NOOP,
    showNotifications: NOOP
};

export const WithNotificationList = React.memo((props: IWithNotificationListProps) => {
    const { children, eventManager, ...rest } = props;
    const notificationEventManager = React.useMemo(() => eventManager || createNotificationEventManager(), [eventManager]);

    React.useEffect(() => {
        NotificationManager.showNotifications = notificationEventManager.showNotifications;
        NotificationManager.removeNotification = notificationEventManager.removeNotification;
        NotificationManager.clearNotifications = notificationEventManager.clearNotifications;
        return () => {
            NotificationManager.showNotifications = NOOP;
            NotificationManager.removeNotification = NOOP;
            NotificationManager.clearNotifications = NOOP;
        };
    }, [notificationEventManager]);

    return (
        <React.Fragment>
            <NotificationList {...rest} eventManager={notificationEventManager} />
            <NotificationEventContext.Provider value={notificationEventManager}>
                {children}
            </NotificationEventContext.Provider>
        </React.Fragment>
    );
});

WithNotificationList.displayName = 'WithNotificationList';
